import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactUsModal = ({ isOpen, onClose, clubInfo }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'استفسار عام',
    message: '',
    phone: ''
  });
  const [sending, setSending] = useState(false);

  const showNotification = (message, type = 'success') => {
    const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';
    const icon = type === 'success' ? '✅' : '❌';

    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 ${bgColor} text-white px-6 py-4 rounded-xl shadow-2xl z-[60]`;
    notification.innerHTML = `
      <div class="flex items-center">
        <span class="text-xl mr-3">${icon}</span>
        <span class="font-medium">${message}</span>
      </div>
    `;
    document.body.appendChild(notification);
    setTimeout(() => {
      if (document.body.contains(notification)) {
        document.body.removeChild(notification);
      }
    }, 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    try {
      await axios.post(`${API}/public/contact-request`, formData);

      setFormData({
        name: '',
        email: '',
        subject: 'استفسار عام',
        message: '',
        phone: ''
      });

      showNotification('تم إرسال رسالتك بنجاح! سنتواصل معك قريباً');
      onClose();

    } catch (error) {
      console.error('خطأ في إرسال الرسالة:', error);
      showNotification('فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى', 'error');
    } finally {
      setSending(false);
    }
  };

  if (!isOpen) return null;

  console.log('ContactUsModal clubInfo:', clubInfo); // Debug log

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-modal-backdrop-fade">
      <div className="bg-white rounded-3xl w-full max-w-2xl max-h-[90vh] overflow-hidden shadow-2xl animate-modal-bounce-in transform-gpu hover:shadow-3xl transition-shadow duration-300">
        
        {/* Premium Header with Gradient Animation */}
        <div className="bg-gradient-to-r from-orange-500 via-orange-600 to-red-600 px-6 py-6 relative overflow-hidden animate-gradient-x">

          {/* Background Animation Elements */}
          <div className="absolute top-0 left-0 w-full h-full">
            <div className="absolute top-2 right-10 w-20 h-20 bg-white/10 rounded-full animate-float"></div>
            <div className="absolute bottom-2 left-10 w-16 h-16 bg-white/5 rounded-full animate-float animation-delay-1s"></div>
            <div className="absolute top-1/2 left-1/2 w-12 h-12 bg-white/5 rounded-full animate-ping-slow"></div>
          </div>

          <div className="flex items-center justify-between relative z-10">
            <div className="flex items-center space-x-4 space-x-reverse">
              {clubInfo?.logo && (
                <div className="relative">
                  <img
                    src={`${API}/files/${clubInfo.logo}`}
                    alt={clubInfo.name}
                    className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-lg animate-premium-logo-float hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 rounded-full border-2 border-white/50 animate-ping-slow"></div>
                </div>
              )}
              <div className="animate-slide-in-right">
                <h2 className="text-2xl font-bold text-white">تواصل معنا</h2>
                <p className="text-orange-100 text-sm animate-fade-in-up animation-delay-200">
                  {clubInfo?.name || 'نادي الأمجاد التقني'}
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 p-2 rounded-xl transition-all duration-300 transform hover:scale-110 hover:rotate-90 hover:shadow-lg animate-fade-in-left"
            >
              <span className="text-2xl">✕</span>
            </button>
          </div>
        </div>

        {/* Content with Enhanced Scrolling */}
        <div className="overflow-y-auto bg-gradient-to-br from-white to-orange-50/30" style={{ maxHeight: 'calc(90vh - 120px)' }}>
          <div className="p-6">
            <div className="mb-6 animate-fade-in-up animation-delay-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
                <span className="text-2xl mr-2 animate-bounce">💬</span>
                نحن هنا لمساعدتك
              </h3>
              <p className="text-gray-600">
                تواصل معنا لأي استفسارات أو مقترحات. سنكون سعداء للرد على جميع رسائلكم في أقرب وقت ممكن.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">الاسم الكامل *</label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                    placeholder="أدخل اسمك الكامل"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">البريد الإلكتروني *</label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                    placeholder="example@domain.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">رقم الهاتف</label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                    placeholder="+966 5X XXX XXXX"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">الموضوع *</label>
                  <select
                    required
                    value={formData.subject}
                    onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors"
                  >
                    <option value="">اختر الموضوع</option>
                    <option value="عضوية">الاستعلام عن العضوية</option>
                    <option value="تدريب">التدريب والأكاديمية</option>
                    <option value="شراكة">شراكة ورعاية</option>
                    <option value="شكوى">شكوى أو مقترح</option>
                    <option value="استفسار عام">استفسار عام</option>
                    <option value="أخرى">أخرى</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">الرسالة *</label>
                <textarea
                  required
                  rows={5}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors resize-none"
                  placeholder="اكتب رسالتك هنا... نحن نقدر آرائكم ومقترحاتكم"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-4 space-x-reverse pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-xl font-semibold transition-colors"
                >
                  إلغاء
                </button>
                <button
                  type="submit"
                  disabled={sending || !formData.name || !formData.email || !formData.subject || !formData.message}
                  className="flex-1 px-6 py-3 bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 disabled:opacity-50 text-white rounded-xl font-semibold transition-colors flex items-center justify-center"
                >
                  {sending ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white ml-2"></div>
                      جاري الإرسال...
                    </>
                  ) : (
                    <>
                      <span className="text-lg ml-2">📨</span>
                      إرسال الرسالة
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsModal;
